/*
  Medilab variant picker helpers (product page).

  theme.js already finds the variant, updates price, images and the add-to-cart
  button. This file adds the parts it doesn't do:

  1. Marks option values that are sold out, or don't exist, given the other
     options picked. They stay selectable (greyed and struck through), so a
     customer can still ask about them.
  2. When the picked combination is sold out or doesn't exist, swaps the
     quantity / Add to cart / Buy it now row for a WhatsApp enquiry that names
     the exact option, instead of leaving a disabled "Sold out" button.

  Works for buttons and dropdowns alike, and for any number of options.
*/
(function () {
  'use strict';

  function init(container) {
    var sid = container.getAttribute('data-section-id');
    var jsonEl = document.getElementById('ProductJson-' + sid);
    var form = document.getElementById('AddToCartForm-' + sid);
    if (!jsonEl || !form || container.hasAttribute('data-ml-variants')) return;
    container.setAttribute('data-ml-variants', '');

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.variants) return;

    var selector = '.single-option-selector-' + sid;

    function inputs() {
      return Array.prototype.slice.call(form.querySelectorAll(selector));
    }

    function selected() {
      var sel = {};
      inputs().forEach(function (el) {
        if (el.type === 'radio') {
          if (el.checked) sel[el.getAttribute('data-index')] = el.value;
        } else {
          sel[el.getAttribute('data-index')] = el.value;
        }
      });
      return sel;
    }

    function find(sel) {
      var keys = Object.keys(sel);
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var k = 0; k < keys.length; k++) {
          if (v[keys[k]] !== sel[keys[k]]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function availableWith(sel, index, value) {
      var trial = {};
      Object.keys(sel).forEach(function (k) { trial[k] = sel[k]; });
      trial[index] = value;
      var v = find(trial);
      return !!(v && v.available);
    }

    function markValues(sel) {
      inputs().forEach(function (el) {
        var index = el.getAttribute('data-index');
        if (el.type === 'radio') {
          var ok = availableWith(sel, index, el.value);
          el.classList.toggle('is-unavailable', !ok);
          var label = el.id ? form.querySelector('label[for="' + el.id + '"]') : null;
          if (label) {
            label.classList.toggle('is-unavailable', !ok);
            var note = label.querySelector('.js-ml-unavailable-text');
            if (note) note.textContent = ok ? '' : ' (sold out)';
          }
        } else if (el.options) {
          Array.prototype.forEach.call(el.options, function (opt) {
            if (!opt.hasAttribute('data-label')) {
              opt.setAttribute('data-label', opt.textContent.replace(/\s+–\s+sold out$/, ''));
            }
            var okOpt = availableWith(sel, index, opt.value);
            opt.textContent = opt.getAttribute('data-label') + (okOpt ? '' : ' – sold out');
          });
        }
      });
    }

    function updateEnquiry(sel, soldOut) {
      var wrap = form.querySelector('.js-contact-soldout');
      if (!wrap) return;
      wrap.classList.toggle('hide', !soldOut);
      var link = wrap.querySelector('.js-ml-soldout-link');
      if (!link || !soldOut) return;
      var values = Object.keys(sel).sort().map(function (k) { return sel[k]; }).filter(Boolean);
      var hasOptions = product.variants.length > 1 && values.length;
      var text = 'Hello Medilab India, is ' + (wrap.getAttribute('data-product-title') || '') +
        (hasOptions ? ' (' + values.join(' / ') + ')' : '') + ' available? ' +
        (wrap.getAttribute('data-product-link') || '');
      // encodeURIComponent, not URLSearchParams: WhatsApp shows a "+" for spaces.
      link.href = link.href.split('?')[0] + '?text=' + encodeURIComponent(text);
    }

    function refresh() {
      var sel = selected();
      markValues(sel);
      var variant = find(sel);
      var soldOut = !variant || !variant.available;
      form.classList.toggle('ml-is-soldout', soldOut);
      updateEnquiry(sel, soldOut);
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches(selector)) {
        // Let theme.js update the button first, then apply ours.
        window.setTimeout(refresh, 0);
      }
    });
    refresh();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
